<div class="dialog-content-wrapper" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary="body">
    <mat-toolbar [color]="'accent'" cdkDragHandle class="m-0"
             fxLayout="row" fxLayoutAlign="space-between center">
        <h2 mat-dialog-title class="title dialog-title m-0 p-0">{{ 'workflows.screens.newBcm.dialogTitle' | translate }}</h2>
            <button data-test="B-Close-dialog" type="button" mat-icon-button (click)="dialogRef.close(false)"
                    [attr.aria-label]="'common.closeDialogAria' | translate">
                <mat-icon>close</mat-icon>
            </button>
    </mat-toolbar>

    <div mat-dialog-content class="p-16 p-sm-24 m-0" fusePerfectScrollbar>

        <mat-tab-group dynamicHeight="true" #tabGroup="matTabGroup">

            <mat-tab [label]="'workflows.screens.newBcm.tabFreemium' | translate" data-test="TH-Freemium">

                <p [innerHTML]="'workflows.screens.newBcm.freemiumIntroHtml' | translate"></p>

                <form>

                    <mat-vertical-stepper linear #stepper>

                        <ng-template matStepperIcon="edit">
                            <mat-icon>edit</mat-icon>
                        </ng-template>

                        <mat-step [stepControl]="formGroup.get('tenant')">
                            <ng-template matStepLabel>{{ 'workflows.screens.newBcm.stepTenant' | translate }}</ng-template>

                            <form-widget-tenant [parentFormGroup]="formGroup"></form-widget-tenant>
                        </mat-step>

                        <mat-step [stepControl]="formGroup.get('user')">
                            <ng-template matStepLabel>{{ 'workflows.screens.newBcm.stepUser' | translate }}</ng-template>

                            <form-widget-user [parentFormGroup]="formGroup"></form-widget-user>
                        </mat-step>

                        <mat-step [stepControl]="formGroup.get('conditionsAndPrivacy')">
                            <ng-template matStepLabel>{{ 'workflows.screens.newBcm.stepAgbPrivacy' | translate }}</ng-template>

                            <form-widget-conditions-and-privacy
                                [parentFormGroup]="formGroup"></form-widget-conditions-and-privacy>
                        </mat-step>

                        <mat-step [stepControl]="formGroup.get('avv')">
                            <ng-template matStepLabel>{{ 'workflows.screens.newBcm.stepAvv' | translate }}</ng-template>

                            <form-widget-avv [parentFormGroup]="formGroup"></form-widget-avv>
                        </mat-step>

                    </mat-vertical-stepper>

                </form>

                <small>{{ 'workflows.screens.newBcm.requiredHint' | translate }}</small><br>
                <small>{{ 'workflows.screens.newBcm.freemiumExtensionsNote' | translate }}</small>
            </mat-tab>

            <mat-tab [label]="'workflows.screens.newBcm.tabPremium' | translate" data-test="TH-Premium">
                <h2>{{ 'workflows.screens.newBcm.premiumHeadline' | translate }}</h2>

                <em>{{ 'workflows.screens.newBcm.comingSoon' | translate }}</em>

                <p [innerHTML]="'workflows.screens.newBcm.premiumPitchHtml' | translate"></p>

                <p class="pt-32 mat-subtitle-1">{{ 'workflows.screens.newBcm.premiumFeaturesTitle' | translate }}</p>
                <ul>
                    <li>{{ 'invoiceCollections.plural' | translate }}</li>
                    <li>{{ 'workflows.screens.newBcm.premiumFeatureElectric' | translate }}</li>
                    <li>{{ 'workflows.screens.newBcm.premiumFeatureTbd' | translate }}</li>
                </ul>

                <p class="mat-subtitle-1">{{ 'workflows.screens.newBcm.inDevelopmentTitle' | translate }}</p>
                <ul>
                    <li>{{ 'workflows.screens.newBcm.devFeatureBerthMap' | translate }}</li>
                    <li>{{ 'workflows.screens.newBcm.devFeatureStats' | translate }}</li>
                    <li>{{ 'workflows.screens.newBcm.devFeatureEtc' | translate }}</li>
                </ul>
            </mat-tab>

        </mat-tab-group>

    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="space-between center">

        <button data-test="B-Abbrechen" type="button" mat-flat-button
                (click)="dialogRef.close(false)"
                [attr.aria-label]="'common.closeDialogAria' | translate">
            <mat-icon>cancel</mat-icon>
            {{ 'common.cancel' | translate }}
        </button>

        <ng-template #saving>
            <mat-icon>save</mat-icon>
            <span>{{ 'common.saving' | translate }}</span>
            <mat-spinner class="saving-spinner" [diameter]="20"></mat-spinner>
        </ng-template>

        <ng-template #notSaving>
            <mat-icon>add_shopping_cart</mat-icon>
            <ng-container *ngIf="tabGroup.selectedIndex === 0">
                {{ 'workflows.screens.newBcm.buyFreeCta' | translate }}
            </ng-container>
            <ng-container *ngIf="tabGroup.selectedIndex > 0">
                {{ 'workflows.screens.newBcm.comingSoon' | translate }}
            </ng-container>
        </ng-template>

        <button data-test="B-Speichern" type="button" mat-flat-button
                (click)="save()"
                class="save-button mat-accent"
                [disabled]="!formGroup.dirty || tabGroup.selectedIndex !== 0 || isSaving"
                [attr.aria-label]="'common.save' | translate">
            <ng-container *ngIf="isSaving; then saving else notSaving"></ng-container>
        </button>

    </div>
</div>
